module.exports = __webpack_public_path__ + "static/media/develop.29fbe8b5.jpg";